export default __webpack_public_path__ + "static/media/product-image-hover-7.9604d9f5.jpg";